import React from "react";
import styled from "styled-components";
import { WHEN_MD, PALETTE } from "../constants";
import { StaticImage } from "gatsby-plugin-image";
import ContentContainer from "./ContentContainer";

const OuterContainer = styled(ContentContainer)`
  background-color: ${PALETTE.DARK_ACCENT[600]};
  display: flex;
  flex-direction: column;

  ${WHEN_MD} {
    padding: 7rem 4rem;
    flex-direction: row;
  }
`;

const InnerLeftContainer = styled.div`
  flex: 1;
  text-align: center;

  ${WHEN_MD} {
    margin-right: 4rem;
    text-align: left;
  }
`;
const InnerRightContainer = styled.div`
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  text-align: center;
  margin-top: 4rem;

  ${WHEN_MD} {
    margin: 0;
    text-align: left;
    border-left: 10px solid white;
  }
`;
const ContentUpperContainer = styled.div``;
const ContentLowerContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Heading = styled.h4`
  margin-bottom: 2rem;
  ${WHEN_MD} {
    margin-bottom: 6rem;
  }
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;

  a {
    margin-right: 0.5rem;
  }

  margin: 0.5rem 0;
  ${WHEN_MD} {
    margin: 0.5rem 0 0;
    justify-content: flex-start;
  }
`;

export default function Footer() {
  return (
    <OuterContainer id="contact">
      <InnerLeftContainer>
        <Heading className="text-white">Contact Us</Heading>
        <StaticImage
          src="../images/undraw-contact-us.svg"
          alt="stroke"
          placeholder="blurred"
          objectFit="contain"
          height={247}
        />
      </InnerLeftContainer>
      <InnerRightContainer>
        <ContentUpperContainer>
          <a href="mailto:support@nofi.so" className="text-white mb-2">
            support@nofi.so
          </a>
          <IconContainer>
            <a href="https://www.notion.so/@nofi">
              <StaticImage
                src="../images/notion-icon.png"
                alt="stroke"
                placeholder="blurred"
                objectFit="contain"
                width={32}
                height={32}
              />
            </a>
            <a href="https://twitter.com/nofi_so">
              <StaticImage
                src="../images/twitter-icon.svg"
                alt="stroke"
                placeholder="blurred"
                objectFit="contain"
                width={32}
                height={32}
              />
            </a>
          </IconContainer>
        </ContentUpperContainer>
        <ContentLowerContainer>
          <a href="/privacy" className="text-white underline">
            Privacy Policy
          </a>
          <a href="terms-of-use" className="text-white underline ">
            Terms of Use
          </a>
          <p className="text-md text-white m-0">© Copyright NoFi Inc. 2023</p>
        </ContentLowerContainer>
      </InnerRightContainer>
    </OuterContainer>
  );
}
